import React from 'react';
import { Global, css } from '@emotion/react';

export const GlobalStyles = () => (
  <>
    <Global
      styles={css`
        /* ------------------------------------------------ */
        /* ----- Basic Setup ----- */
        /* ------------------------------------------------ */

        :root {
          --important: #fff;
          --sub: #eee;
          --body: #ccc;
          --divider: #333;

          --orange: #d36b00;

          --bg: #020202;

          --x-small: 1.5rem;
          --small: 2rem;
          --base: 2.4rem;
          --normal: 2.6rem;
          --medium: 3.2rem;

          --large: 4rem;
          --x-large: 5rem;
          --xx-large: 6rem;
          --huge: 8rem;

          --xxs: 0.5rem;
          --xs: 1rem;
          --xsm: 1.5rem;
          --sm: 2rem;
          --md: 3rem;
          --lg: 4rem;
          --xl: 5rem;
          --2xl: 7rem;
          --3xl: 12rem;
          --4xl: 17rem;
        }

        *,
        *::before,
        *::after {
          margin: 0;
          padding: 0;
          box-sizing: inherit;
        }

        html {
          box-sizing: border-box;
          font-size: 62.5%;

          @media (max-width: 1060px) {
            font-size: 54%;
          }
        }

        body {
          font-family: "Jost", sans-serif;
          font-weight: 300;
          font-size: var(--base);
          color: var(--body);
          background: var(--bg);
          line-height: 1.6;
        }

        .row {
          max-width: 1400px;
          width: 100%;
          margin: auto;

          @media (max-width: 1600px) {
            padding: 0 var(--2xl);
          }

          @media (max-width: 820px) {
            padding: 0 var(--xl);
          }

          @media (max-width: 730px) {
            padding: 0 var(--lg);
          }

          @media (max-width: 530px) {
            padding: 0 var(--sm);
          }
        }

        section {
          margin-top: var(--4xl);

          @media (max-width: 1060px) {
            margin-top: var(--3xl);
          }

          & .h2 {
            margin-bottom: var(--lg);

            @media (max-width: 720px) {
              margin-bottom: var(--md);
            }
          }
        }

        /* ------------------------------------------------ */
        /* ----- Typography ----- */
        /* ------------------------------------------------ */

        h1,
        h2,
        h3 {
          color: var(--important);
          font-weight: 400;
          line-height: 1.1;
        }

        .h1 {
          font-size: var(--huge);

          @media (max-width: 1060px) {
            font-size: var(--xx-large);
          }
        }

        .h2 {
          font-size: var(--xx-large);

          @media (max-width: 1060px) {
            font-size: var(--x-large);
          }
        }

        /* ------------------------------------------------ */
        /* ----- Links & Buttons ----- */
        /* ------------------------------------------------ */

        button,
        input[type="submit"] {
          background: none;
          border: none;
          font-family: inherit;
        }

        a,
        button,
        input[type="submit"] {
          text-decoration: none;
          cursor: pointer;
          color: inherit;
          transition: all 0.2s;
        }

        [class*="btn"],
        input[type="submit"] {
          display: inline-block;
          font-weight: 400;
          text-transform: uppercase;
          color: var(--important);
          font-size: var(--small);
          letter-spacing: 5px;
          border-radius: 100px;
          border: 1px solid var(--orange);
          padding: 1.2rem var(--lg);

          &:hover,
          &:focus {
            background: var(--orange);
          }
        }

        .btn-sm {
          padding: var(--xxs) var(--sm);
          font-size: var(--x-small);
        }

        .btn-cta {
          margin-top: 20px; /* Adjust the value as needed */
        }
        ,
        input[type="submit"] {
          background: var(--orange);

          &:hover,
          &:focus {
            background: transparent;
          }
        }

        .form-control {
          display: block;
          width: 100%;
          background-color: transparent;
          border: 1px solid rgb(50, 49, 49);
          outline: none;
          color: #fff;
          padding: 10px;
          border-radius: 6px;
          font-size: 14px;
        }

        .form-control:focus {
          border-color: #d36b00;
          transition: all 0.2s;
        }

        .form-group {
          margin-bottom: 10px;
        }
        .form-label {
          font-size: 14px;
          color: rgb(190, 188, 188);
          margin-bottom: 4px;
        }

        .form-submit-button {
          border: none;
          outline: none;
          background-color: #d36b00;
          color: #fff;
          padding: 8px 20px;
          border-radius: 6px;
          font-weight: 700;
        }
        .blog-post section {
          text-align: center;
          max-width: 630px;
          margin: 0 auto;
        }
        .blog-post img {
          max-width: 100%;
        }
      `}
    />
  </>
);
